export enum CommentStatus {
  TO_AUDIT = "TO_AUDIT",
  PUBLISH = "PUBLISH",
  RUBBISH = "RUBBISH",
  BAN = "BAN",
}
